module.exports = __webpack_public_path__ + "media/images/logo-ever-factor-footer-01-1a95b360dcfe4efcce5d72f5c3858183.svg";